

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { CasinoEnabledProvider } from './context/CasinoEnabledContext';

// Stop the browser from restoring the old scroll position on back/forward
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CasinoEnabledProvider>
      <App />
    </CasinoEnabledProvider>
  </Provider>
);
reportWebVitals();